import React from 'react';

import InteractiveHeaderCell, {
  IconVisibility,
  InteractiveHeaderCellProps,
} from 'ui-library/simple-table/InteractiveHeaderCell';

export type SortIcon = 'arrow-up' | 'arrow-down' | null;

export type SortableHeaderCellProps = Omit<InteractiveHeaderCellProps, 'iconInfos'> & {
  sortIcon: SortIcon;
  onToggleSort: () => void;
};

export default function SortableHeaderCell(props: SortableHeaderCellProps): JSX.Element {
  return (
    <InteractiveHeaderCell
      {...props}
      iconInfos={[
        {
          icon: props.sortIcon ?? 'arrow-down',
          onClick: props.onToggleSort,
          visibility: props.sortIcon ? IconVisibility.ALWAYS : IconVisibility.ON_HOVER,
        },
      ]}
    />
  );
}
